<template>
  <div>
    <el-card class="box-card box-cards" shadow="never">
      <el-row>
        <el-form :inline="true" class="user-search">
          <el-col :span="16">
            <el-form-item>
              <div class="card_top"><span>词书单词列表</span></div>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formInline.params.unitId" placeholder="单元" style="width: 80px;">
                <el-option value="">全部</el-option>
                <el-option value="0">未设置</el-option>
                <el-option v-for="item in units" :key="item.id" :label="item.title" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formInline.params.wordType" placeholder="类型" style="width: 80px;">
                <el-option value="">全部</el-option>
                <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input size="small" v-model="formInline.params.name" placeholder="输入关键字"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="text-align: right;">
            <el-button-group size="small">
              <el-button type="success" size="small" icon="el-icon-upload2" @click="importWord">导入词库</el-button>
              <el-button type="success" size="small" icon="el-icon-upload2" @click="importAudio">导入读音</el-button>
              <el-button type="warning" size="small" icon="el-icon-upload2" @click="importYongAudio">导入用音</el-button>
            </el-button-group>

            <el-button size="small" type="primary" plain @click="handleEdit()">添加
            </el-button>
          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <el-card class="box-card box-cards2" shadow="never">
      <el-empty v-if="!loading && tableData.length < 1" description="暂无单词"></el-empty>
      <el-collapse v-model="activeName" accordion>

        <el-collapse-item v-for="(item, index) in tableData" :key="index" :name="index">
          <template slot="title">
            {{ index + 1 }}、{{ item.word.word }}
            <div>
              <el-link icon="el-icon-edit" type="primary" style="margin-left: 10px;"
                @click.capture.stop="handleEdit(index, item)">编辑</el-link>
              <el-link icon="el-icon-delete" type="danger" style="margin-left: 10px;"
                @click.capture.stop="handleEditdel(item.word.id)">删除 </el-link>
            </div>
          </template>
          <div>
            <el-row :gutter="20">
              <el-col :span="4">
                <div class="">单词id：{{ item.word.id }}</div>
              </el-col>
              <el-col :span="4">
                <div class="">单元：{{ item.wordUnit ? item.wordUnit.title : '-' }}</div>
              </el-col>
              <el-col :span="6">
                <div class="">音标：<span v-if="item.word.multiPhonetic">
                    <span v-for="(v, k) in item.word.multiPhonetic" style="margin-right: 10px;"><i>{{ k }}</i> {{ v
                    }}</span>
                  </span>
                  <span v-else>{{ item.word.phonetic }}</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="">排序：{{ item.word.sort }}</div>
              </el-col>
              <el-col :span="6">
                <div class="">单词类型：{{ getWordType(item.word.wordType) }} </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="2">音频URL：</el-col>
              <el-col :span="20">
                <div v-if="item.word.audioUk" class=""><audio controls class="audioPlayer">
                    <source :src="item.word.audioUk" type="audio/mpeg">
                    您的浏览器不支持 audio 元素。
                  </audio><br />
                  {{ item.word.audioUk }}
                </div>
                <span v-else>无</span>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="2">
                <div class="" style="padding-top: 5px;">记：</div>
              </el-col>
              <el-col :span="20">
                <div v-html="item.word.rememberHtml"> </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="2">释义：</el-col>
              <el-col :span="20">
                <div class=""><span v-if="item.word.definitionPrefix">{{ item.word.definitionPrefix }}</span><i>{{
                  item.word.pos
                }}</i> <span v-html="parseDefinition(item.word.definition)"></span>
                  <div v-for="def in item.definitionList">
                    <i>{{ def.pos }}</i> <span v-html="parseDefinition(def.definition)"></span>
                  </div>
                </div>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="2">
                <div class="" style="padding-top: 5px;">用：</div>
              </el-col>
              <el-col :span="20">
                <div v-for="(yong, index) in item.yongList" :key="index">
                  <span v-html="yong.exampleHtml"></span>
                  <span style="color: grey;margin-left: 4px;">{{ yong.definition }}</span>
                  <el-tag v-for="tag in yong.tags" :key="tag" type="" effect="plain" size="mini"
                    style="margin-right:4px">{{
                      tag
                    }}</el-tag>
                  <el-button type="text" icon="el-icon-edit" @click.capture="showEditYong(yong)"
                    size="mini">编辑</el-button>
                </div>
              </el-col>
            </el-row>

            <el-row v-if="item.variantList && item.variantList.length > 0" :gutter="20">
              <el-col :span="2">
                <div class="" style="padding-top: 5px;">变：</div>
              </el-col>
              <el-col :span="20">
                <div v-for="(variant, index) in item.variantList" :key="index">
                  [{{ variant.tag }}] {{ variant.word }}
                </div>
              </el-col>
            </el-row>
            <el-row v-if="item.extendList && item.extendList.length > 0" :gutter="20">
              <el-col :span="2">
                <div class="" style="padding-top: 5px;">扩：</div>
              </el-col>
              <el-col :span="20">
                <div v-for="(ext, index) in item.extendList" :key="index">
                  [{{ ext.tag }}] {{ ext.word }} <i>{{ ext.pos }}</i> <span
                    v-html="parseDefinition(ext.definition)"></span>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-collapse-item>
      </el-collapse>


      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </el-card>
    <el-dialog :visible.sync="uploadVisible">
      <div>
        <el-form label-position="top">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="词书ID">
                <el-input v-model="uploadParam.bookId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单词类型">
                <el-select v-model="uploadParam.wordType">
                  <el-option v-for="opt in options" :key="opt.id" :value="opt.id" :label="opt.name" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="表格序号">
                <el-input v-model="uploadParam.sheetIndex"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-upload class="upload-excel" ref="excelUploader" name="file" :on-preview="handlePreview"
          :on-remove="handleRemove" :action="excelsrc" :multiple="false" :headers="uploadHeader" :file-list="fileList"
          :auto-upload="false" :on-success="uploadSuccess" :on-error="uploadError">
          <el-button slot="trigger" size="mini" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">上传词库Excep文件，第一行必须是表头(单元，单词，音标，记，义，用，变，扩)</div>
        </el-upload>
        <span v-if="uploading" style="margin-top: 8px;">正在处理...</span>
        <span style="margin-top: 8px;">{{ excelMessage }}</span>
      </div>

      <span slot="footer">
        <el-button @click="uploadVisible = false">取 消</el-button>
        <el-button type="primary" :loading="uploading" @click="doImport">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="uploadAudioVisible">
      <div>
        <el-form label-position="top">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="词书ID">
                <el-input v-model="uploadAudioParam.bookId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="忽略已存在">
                <el-select v-model="uploadAudioParam.ignore">
                  <el-option :value="1" label="忽略" />
                  <el-option :value="0" label="重新上传" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-upload class="upload-excel" ref="audioUploader" name="file" :action="audiosrc" :multiple="false"
          :headers="uploadHeader" :auto-upload="false" :on-success="uploadAudioSuccess" :on-error="uploadAudioError">
          <el-button slot="trigger" size="mini" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">上传单词读音ZIP文件包，50MB以内，文件名为单词，格式mp3</div>
        </el-upload>
        <span v-if="audioUploading" style="margin-top: 8px;">正在处理...</span>
        <span style="margin-top: 8px;">{{ audioMessage }}</span>
      </div>

      <span slot="footer">
        <el-button @click="uploadAudioVisible = false">取 消</el-button>
        <el-button type="primary" :loading="audioUploading" @click="doAudioImport">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="uploadYongAudioVisible">
      <div>
        <el-form label-position="top">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item label="词书ID">
                <el-input v-model="uploadAudioParam.bookId"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="忽略已存在">
                <el-select v-model="uploadAudioParam.ignore">
                  <el-option :value="1" label="忽略" />
                  <el-option :value="0" label="重新上传" />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-upload class="upload-excel" ref="yongAudioUploader" name="file" :action="yongaudiosrc" :multiple="false"
          :headers="uploadHeader" :auto-upload="false" :on-success="uploadYongAudioSuccess"
          :on-error="uploadYongAudioError">
          <el-button slot="trigger" size="mini" type="primary">选择文件</el-button>
          <div slot="tip" class="el-upload__tip">上传用读音ZIP文件包，50MB以内，文件名为用句，格式mp3</div>
        </el-upload>
        <span v-if="yongAudioUploading" style="margin-top: 8px;">正在处理...</span>
        <span style="margin-top: 8px;">{{ yongAudioMessage }}</span>
      </div>

      <span slot="footer">
        <el-button @click="uploadYongAudioVisible = false">取 消</el-button>
        <el-button type="primary" :loading="yongAudioUploading" @click="doYongAudioImport">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="editYongVisible">
      <div>
        <el-form label-position="top">
          <el-form-item label="用句">
            <el-input v-model="editYong.example"></el-input>
          </el-form-item>
          <el-form-item label="释义">
            <el-input v-model="editYong.definition"></el-input>
          </el-form-item>
          <el-form-item label="标签">
            <el-input v-model="editYong.tag"></el-input>
          </el-form-item>
          <el-form-item label="匹配词">
            <el-input v-model="editYong.word"></el-input>
          </el-form-item>
          <el-form-item label="用句音频">
            <el-upload class="upload-excel" ref="yongUploader" name="files" :action="imagesrc" :multiple="false"
              :headers="uploadHeader" :on-success="yongAudioSuccess">
              <el-button slot="trigger" size="mini" type="primary">选择文件</el-button>
              <div slot="tip" class="el-upload__tip">{{ editYong.audioUrl }}</div>
            </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer">
        <el-button @click="editYongVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveYong">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer :title="title" :visible.sync="editFormVisible" :before-close="handleClose" direction="rtl"
      custom-class="demo-drawer" ref="drawer" size="60%">
      <div class="demo-drawer__content">
        <el-row>
          <el-form label-width="110px" :model="editForm" :rules="rules" ref="editForm">
            <el-col :span="22">
              <div class="grid-content bg-purple">
                <el-row>
                  <el-col :span="14">
                    <el-form-item label="所属单元" prop="unitId">
                      <el-select v-model="editForm.params.word.unitId" placeholder="请选择所属单元">
                        <el-option v-for="item in units" :key="item.id" :label="item.title" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="	单词类型" prop="wordType">
                      <el-select v-model="editForm.params.word.wordType" placeholder="请选择单词类型">
                        <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="16">
                    <el-form-item label="单词" prop="word">
                      <el-input v-model="editForm.params.word.word" placeholder="请输入单词名称"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="排序" prop="sort">
                      <el-input v-model="editForm.params.word.sort" placeholder="越小越靠前"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-form-item label="音标" prop="phonetic">
                  <el-input v-model="editForm.params.word.phonetic" type="textarea" :row="2"
                    placeholder="请输入音标"></el-input>
                </el-form-item>
                <el-form-item label="音频URL：" prop="logo">
                  <el-upload class="upload-demo" name="files" :action="imagesrc" :headers="uploadHeader"
                    :show-file-list="false" :on-success="licenseSuccess">
                    <el-button size="mini" type="primary">点击上传</el-button>
                    <div slot="tip" class="el-upload__tip">{{ editForm.params.word.audioUk }}</div>
                  </el-upload>
                </el-form-item>
                <el-form-item label="记" prop="remember">
                  <el-input v-model="editForm.params.word.remember" placeholder="请输入记"></el-input>
                </el-form-item>
                <el-form-item label="预览" prop="remember">
                  <div v-html="previewMarkdown"></div>
                </el-form-item>
                <el-card style="margin-left: 16px;margin-bottom: 8px;">
                  <div slot="header" class="clearfix">
                    <el-form-item label="释义" prop="name" style="margin-bottom: 0;">
                      <el-row>
                        <el-col :span="5">
                          <el-input v-model="editForm.params.word.definitionPrefix" placeholder="释义前置说明"></el-input>
                        </el-col>
                        <el-col :span="5">
                          <el-autocomplete v-model="editForm.params.word.pos" :fetch-suggestions="querySearch"
                            placeholder="请输入词性"></el-autocomplete>
                        </el-col>
                        <el-col :span="14">
                          <el-input v-model="editForm.params.word.definition" placeholder="请输入释义"></el-input>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="用" prop="name">
                      <template v-for="(yong, index) in editForm.params.yongList">
                        <el-row v-if="yong.wordDefinitionId == 0" style="margin-bottom: 4px;">
                          <el-col :span="9">
                            <el-input v-model="yong.example" placeholder="请输入用法"></el-input>
                          </el-col>
                          <el-col :span="10">
                            <el-input v-model="yong.definition" placeholder="请输入释义"></el-input>
                          </el-col>
                          <el-col :span="3">
                            <el-input v-model="yong.tag" placeholder="标签"></el-input>
                          </el-col>
                          <el-col :span="2">
                            <el-button @click="delYong(index)" icon="el-icon-remove-outline" size="small"
                              circle></el-button>
                          </el-col>
                        </el-row>
                      </template>
                      <el-button @click="addYong(0)" icon="el-icon-plus" size="small">添加</el-button>
                    </el-form-item>
                  </div>
                </el-card>
                <el-card v-for="(def, defIndex) in editForm.params.definitionList" :key="defIndex"
                  style="margin-left: 16px;margin-bottom: 8px;">
                  <div slot="header" class="clearfix">
                    <el-form-item label="释义" prop="name" style="margin-bottom: 0;">
                      <el-row style="margin-top: 4px;">
                        <el-col :span="5">
                          <el-input v-model="editForm.params.word.definitionPrefix" placeholder="释义前置说明"></el-input>
                        </el-col>
                        <el-col :span="5">
                          <el-autocomplete v-model="def.pos" placeholder="请输入词性"
                            :fetch-suggestions="querySearch"></el-autocomplete>
                        </el-col>
                        <el-col :span="11">
                          <el-input v-model="def.definition" placeholder="请输入释义"></el-input>
                        </el-col>
                        <el-col :span="3">
                          <el-button @click="delDefinition(defIndex)" icon="el-icon-remove-outline" size="small"
                            circle></el-button>
                        </el-col>
                      </el-row>
                    </el-form-item>
                  </div>
                  <div>
                    <el-form-item label="用" prop="name">
                      <template v-for="(yong, index) in editForm.params.yongList">
                        <el-row v-if="yong.wordDefinitionId == def.id" style="margin-bottom: 4px;">
                          <el-col :span="9">
                            <el-input v-model="yong.example" placeholder="请输入用法"></el-input>
                          </el-col>
                          <el-col :span="10">
                            <el-input v-model="yong.definition" placeholder="请输入释义"></el-input>
                          </el-col>
                          <el-col :span="3">
                            <el-input v-model="yong.tag" placeholder="标签"></el-input>
                          </el-col>
                          <el-col :span="2">
                            <el-button @click="delYong(index)" icon="el-icon-remove-outline" size="small"
                              circle></el-button>
                          </el-col>
                        </el-row>
                      </template>
                      <el-button @click="addYong(def.id)" icon="el-icon-plus" size="small">添加</el-button>
                    </el-form-item>
                  </div>
                </el-card>
                <el-button @click="addDefinition" icon="el-icon-plus" size="small"
                  style="margin-left: 16px;margin-bottom: 16px;">添加义项及用法</el-button>
                <el-form-item label="变" prop="name">
                  <el-row v-for="(variant, index) in editForm.params.variantList" :key="index"
                    style="margin-bottom: 4px;">
                    <el-col :span="6">
                      <el-input v-model="variant.tag" placeholder="标签"></el-input>
                    </el-col>
                    <el-col :span="16">
                      <el-input v-model="variant.word" placeholder="请输入单词"></el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-button @click="delVariant(index)" icon="el-icon-remove-outline" size="small"
                        circle></el-button>
                    </el-col>
                  </el-row>
                  <el-button @click="addVariant" icon="el-icon-plus" size="small">添加</el-button>
                </el-form-item>

                <el-form-item label="扩" prop="name">
                  <el-row v-for="(ext, index) in editForm.params.extendList" :key="index" style="margin-bottom: 4px;">
                    <el-col :span="3">
                      <el-input v-model="ext.tag" placeholder="标签"></el-input>
                    </el-col>
                    <el-col :span="6">
                      <el-input v-model="ext.word" placeholder="请输入单词"></el-input>
                    </el-col>
                    <el-col :span="3">
                      <el-autocomplete v-model="ext.pos" placeholder="请输入词性"
                        :fetch-suggestions="querySearch"></el-autocomplete>
                    </el-col>
                    <el-col :span="10">
                      <el-input v-model="ext.definition" placeholder="请输入释义"></el-input>
                    </el-col>
                    <el-col :span="2">
                      <el-button @click="delExtend(index)" icon="el-icon-remove-outline" size="small"
                        circle></el-button>
                    </el-col>
                  </el-row>
                  <el-button @click="addExtend" icon="el-icon-plus" size="small">添加</el-button>
                </el-form-item>
              </div>
            </el-col>
          </el-form>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="handleClose">取消</el-button>
          <el-button size="small" type="goon" class="title" @click="submitForm('editForm')">
            保存</el-button>
        </div>
        <div style="height: 60px; margin-top: 50px"></div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { VueEditor } from "vue2-editor";
import marked from "../../utils/markdown"
import Pagination from "../../components/Pagination";
import debounce from "../../utils/debounce";
import { wordslist, wordsdelete, wordssave, wordsupdate, bookstypes, bookunitlist, wordslistpos, wordsyongword, imagesrc, getUploadHeader, getExcelSrc, getAudioSrc, getYongAudioSrc } from "../../api/userMG";
import { parsePhonetic, parseDefinition, parseYong } from "../../utils/utils";

var newDefId = -1;

export default {
  data() {
    return {
      activeName: 0,
      title: "编辑信息",
      units: [],
      poses: [],
      options: [],
      editFormVisible: false,
      //分页
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10,
      },
      imagesrc: "", //图片
      uploadHeader: {},
      excelsrc: "",
      uploadVisible: false,
      uploading: false,
      excelMessage: '',
      fileList: [],
      uploadParam: {
        bookId: 0,
        wordType: 1,
        sheetIndex: 0
      },
      yongaudiosrc: "",
      uploadYongAudioVisible: false,
      yongAudioUploading: false,
      yongAudioMessage: '',
      audiosrc: "",
      uploadAudioVisible: false,
      audioUploading: false,
      audioMessage: '',
      uploadAudioParam: {
        bookId: 0,
        ignore: 1
      },
      loading: true,
      tableData: [], //表格数据 
      formInline: {
        data: {},
        params: {
          pageNum: 1,
          pageSize: 10,
          bookId: 0,
          unitId: "",
          wordType: "",
          name: ""
        },
      },
      editYongVisible: false,
      editYong: {
        id: '',
        example: '',
        definition: '',
        tag: '',
        word: '',
        audioUrl: '',
      },
      dialogImageUrl: '',
      dialogVisible: false,
      previewMarkdown: "",
      //添加，修改数据
      editForm: {
        data: {},
        params: {
          word: {
            "id": 0,
            "bookId": 0,
            "unitId": 0,
            "word": "",
            "phonetic": "",
            "remember": "",
            "multiPhonetic": "",
            "definitionPrefix": "",
            "pos": "",
            "definition": "",
            "audioUk": "",
            "difficultyLevel": "",
            "wordType": ""
          },
          definitionList: [],
          yongList: [{
            "id": 0,
            "wordId": 0,
            "audioUrl": " ",
            "example": "",
            "definition": "",
            "tag": "",
            "createdAt": "",
            "updatedAt": ""
          }],
          variantList: [],
          extendList: []
        },
      },
      //规则验证
      rules: {},

    };
  },
  watch: {
    "editForm.params.word.remember": {
      handler(newval, oldval) {
        this.previewMarkdown = marked(newval ? newval : "")
      }
    }
  },
  components: {
    Pagination,
    VueEditor
  },
  created() {
    //md.enable(['sub', 'sup', 'ins'])


    this.formInline.params.bookId = this.$route.query.id;
    if (this.$route.query.unitId && parseInt(this.$route.query.unitId)) this.formInline.params.unitId = parseInt(this.$route.query.unitId);
    this.uploadParam.bookId = this.$route.query.id;
    this.uploadAudioParam.bookId = this.$route.query.id;
    this.imagesrc = imagesrc;//上传地址
    this.uploadHeader = getUploadHeader()
    this.excelsrc = getExcelSrc(this.uploadParam)
    this.audiosrc = getAudioSrc(this.uploadAudioParam)
    this.yongaudiosrc = getYongAudioSrc(this.uploadAudioParam)

    this.getWordTypes() //获取词书类型
    //数据列表
    this.getlist(this.formInline);
    this.getUnitList()
    this.getPoses()
  },
  methods: {
    headStyle() {
      return {
        background: "#A1BBFF",
        color: "#fff",
        letterSpacing: "2px",
        border: " 1px solid #A1BBFF",
        textAlign: "center",
        height: "39px",
      };
    },
    getWordTypes() {
      bookstypes({
        params: { id: this.formInline.params.bookId }
      }).then((res) => {
        if (res.code != 200) {
          this.$message({
            type: "info",
            message: res.message,
          });
        } else {
          this.options = res.data
        }
      }).catch(() => { })

    },
    //显示数据
    getlist(parameter) {
      this.loading = true;
      wordslist(parameter)
        .then((res) => {
          this.loading = false;
          if (res.code != 200) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {

            this.tableData = res.data.records.map((w) => {
              if (w.word.remember) {
                w.word.rememberHtml = marked(w.word.remember)
              }
              if (w.word.multiPhonetic) {
                w.word.multiPhonetic = parsePhonetic(w.word.multiPhonetic)
              }
              if (w.yongList) {
                w.yongList = w.yongList.map((y) => {
                  return parseYong(y, w.word.word, w.variantList)
                })
              }
              return w
            });
            // 分页赋值
            this.pageparm.currentPage = this.formInline.params.pageNum;
            this.pageparm.pageSize = this.formInline.params.pageSize;

            this.pageparm.total = res.data.total;

            var audios = document.querySelectorAll('.audioPlayer')
            for (var i = 0; i < audios.length; i++) {
              audios[i].load();
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          console.error(err)
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    getUnitList() {
      //this.loading = true;
      var parameter = {
        data: {},
        params: {
          pageNum: 1,
          pageSize: 100,
          bookId: this.formInline.params.bookId
        },
      }
      bookunitlist(parameter)
        .then((res) => {
          //this.loading = false;
          if (res.code != 200) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.units = res.data.records;
          }
        })
        .catch((err) => {
          //this.loading = false;
          console.error(err)
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    getPoses() {
      //this.loading = true;
      var parameter = {
        params: {
        },
      }
      wordslistpos(parameter)
        .then((res) => {
          //this.loading = false;
          if (res.code != 200) {
            this.$message({
              type: "info",
              message: res.message,
            });
          } else {
            this.poses = res.data.map((t) => { return { value: t } });
          }
        })
        .catch((err) => {
          //this.loading = false;
          this.$message.error("加载失败，请稍后再试！");
        });
    },
    parseDefinition,
    getWordType(type) {
      for (var i in this.options) {
        if (this.options[i].id == type) {
          return this.options[i].name
        }
      }
      return ""
    },
    querySearch(queryString, cb) {
      var restaurants = this.poses;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.params.pageNum = parm.currentPage;
      this.formInline.params.pageSize = parm.pageSize;
      this.getlist(this.formInline);
    },
    // 搜索事件
    search() {
      // console.log(this.formInline.params)
      this.formInline.params.pageNum = 1;
      this.getlist(this.formInline); //显示
    },
    //关闭弹框
    handleClose(done) {
      this.$confirm("还有未保存的工作哦确定关闭吗？")
        .then((_) => {
          this.editFormVisible = false
          // done();
        })
        .catch((_) => { });
    },
    //上传头像
    licenseSuccess(response, file) {
      this.editForm.params.word.audioUk = response.data[0].url
    },
    yongAudioSuccess(response, file) {
      this.editYong.audioUrl = response.data[0].url
    },
    setYongWord(yong) {
      this.$prompt('请输入匹配词', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: yong.word,
      }).then(({ value }) => {
        wordsyongword({
          params: {
            id: yong.id,
            word: value
          }
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '设置成功！'
          });
          this.getlist(this.formInline)
        }).catch(() => { })
      }).catch(() => { });
    },
    showEditYong(yong) {
      this.editYong.id = yong.id
      this.editYong.example = yong.example
      this.editYong.definition = yong.definition
      this.editYong.tag = yong.tag
      this.editYong.word = yong.word
      this.editYong.audioUrl = yong.audioUrl
      this.editYongVisible = true
    },
    saveYong() {
      wordsyongword({
        params: this.editYong
      }).then((res) => {
        this.$message({
          type: 'success',
          message: '编辑成功！'
        });
        this.editYongVisible = false
        this.getlist(this.formInline)
      }).catch(() => { })
    },
    //添加，修改
    handleEdit(index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {//修改
        var editObj = JSON.parse(JSON.stringify(row))
        if (editObj.word.multiPhonetic) {
          var phonetic = []
          var mp = editObj.word.multiPhonetic instanceof String ? JSON.parse(editObj.word.multiPhonetic) : editObj.word.multiPhonetic
          for (var i in mp) {
            phonetic.push(i + mp[i])
          }
          editObj.word.phonetic = phonetic.join("\r\n")
          delete editObj.word.multiPhonetic
        }
        if (editObj.word.rememberHtml) {
          delete editObj.word.rememberHtml
        }

        if (editObj.yongList) {
          editObj.yongList = editObj.yongList.map((y) => {
            delete y.exampleHtml
            delete y.tags
            return y
          })
        }

        this.editForm = {
          data: {},
          params: editObj,
        }

      } else {//添加   
        this.editForm = {
          data: {},
          params: {
            word: {
              "id": 0,
              "audioUk": "",
              "bookId": this.$route.query.id,
              "unitId": null,
              "word": "",
              "phonetic": "",
              "definitionPrefix": "",
              "pos": "",
              "definition": "",
              "remember": "",
              "wordType": "",
              "importance": 1,
              "difficultyLevel": ""
            },
            definitionList: [],
            yongList: [],
            variantList: [],
            extendList: []
          },
        }

      }
    },
    addDefinition() {
      if (!this.editForm.params.definitionList) {
        Vue.set(this.editForm.params, 'definitionList', [])
      }

      this.editForm.params.definitionList.push({
        id: newDefId--,
        pos: "",
        definition: ""
      })
    },
    delDefinition(index) {
      if (!this.editForm.params.definitionList) return;
      this.$confirm('确定删除该义项？').then((c) => {
        this.editForm.params.definitionList.splice(index, 1)
      }).catch((_) => { })
    },
    addYong(defId) {
      if (!this.editForm.params.yongList) {
        Vue.set(this.editForm.params, 'yongList', [])
      }

      this.editForm.params.yongList.push({
        wordDefinitionId: defId,
        example: "",
        definition: "",
        tag: ""
      })
    },
    delYong(index) {
      if (!this.editForm.params.yongList) return;
      this.$confirm('确定删除该用法？').then((c) => {
        this.editForm.params.yongList.splice(index, 1)
      }).catch((_) => { })
    },
    addVariant() {
      if (!this.editForm.params.variantList) {
        Vue.set(this.editForm.params, 'variantList', [])
      }
      this.editForm.params.variantList.push({
        tag: "",
        word: ""
      })
    },
    delVariant(index) {
      if (!this.editForm.params.variantList) return;
      this.$confirm('确定删除该变体？').then((c) => {
        this.editForm.params.variantList.splice(index, 1)
      }).catch((_) => { })
    },
    addExtend() {
      if (!this.editForm.params.extendList) {
        Vue.set(this.editForm.params, 'extendList', [])
      }
      this.editForm.params.extendList.push({
        tag: "",
        word: "",
        pos: "",
        definition: ""
      })
    },
    delExtend(index) {
      if (!this.editForm.params.extendList) return;
      this.$confirm('确定删除该扩展？').then((c) => {
        this.editForm.params.extendList.splice(index, 1)
      }).catch((_) => { })
    },

    importWord() {
      this.uploadVisible = true
      this.uploading = false
      this.excelMessage = ""
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    doImport() {
      if (this.$refs.excelUploader.uploadFiles.length < 1) {
        this.$message({
          message: "请选择文件！",
          type: "error",
        })
        return;
      }
      this.excelsrc = getExcelSrc(this.uploadParam)
      this.uploading = true
      this.excelMessage = ""
      setTimeout(() => {
        this.$refs.excelUploader.submit();
      }, 200)
    },
    uploadSuccess(params) {
      var data = params ? params.data : null
      if (data) {
        this.$message({
          message: "处理成功！",
          type: "success",
        })
        this.excelMessage = "新加单词 " + data.insert + "; 更新单词 " + data.update;
      } else {
        this.$message({
          message: (params && params.message) ? params.message : "处理成功！",
          type: "error",
        })
        if (params && params.message) {
          this.excelMessage = params.message;
        } else {
          this.excelMessage = "";
        }
      }
      this.uploading = false
      this.$refs.excelUploader.clearFiles()
    },
    uploadError(err) {
      this.$message({
        message: "上传错误！",
        type: "error",
      })
      this.excelMessage = err.description ? err.description : err.toString()
      this.uploading = false
    },
    importAudio() {
      this.uploadAudioVisible = true
      this.audioUploading = false
      this.audioMessage = ""
    },
    doAudioImport() {
      if (this.$refs.audioUploader.uploadFiles.length < 1) {
        this.$message({
          message: "请选择文件！",
          type: "error",
        })
        return;
      }
      this.audiosrc = getAudioSrc(this.uploadAudioParam)
      this.audioUploading = true
      this.audioMessage = ""
      setTimeout(() => {
        this.$refs.audioUploader.submit();
      }, 200)
    },
    uploadAudioSuccess(params) {

      var data = params ? params.data : null
      if (data) {
        this.$message({
          message: "处理成功！",
          type: "success",
        })
        this.audioMessage = "更新音频 " + data.success + "; 忽略 " + data.ignore + "; 错误 " + data.fail;
      } else {
        this.$message({
          message: (params && params.message) ? params.message : "处理失败！",
          type: "error",
        })
      }
      this.audioUploading = false
      this.$refs.audioUploader.clearFiles()
    },
    uploadAudioError(err) {
      this.$message({
        message: "上传错误！",
        type: "error",
      })
      this.audioMessage = err.description ? err.description : err.toString()
      this.audioUploading = false
    },
    importYongAudio() {
      this.uploadYongAudioVisible = true
      this.yongAudioUploading = false
      this.yongAudioMessage = ""
    },
    doYongAudioImport() {
      if (this.$refs.yongAudioUploader.uploadFiles.length < 1) {
        this.$message({
          message: "请选择文件！",
          type: "error",
        })
        return;
      }
      this.yongaudiosrc = getYongAudioSrc(this.uploadAudioParam)
      this.yongAudioUploading = true
      this.yongAudioMessage = ""
      setTimeout(() => {
        this.$refs.yongAudioUploader.submit();
      }, 200)
    },
    uploadYongAudioSuccess(params) {

      var data = params ? params.data : null
      if (data) {
        this.$message({
          message: "处理成功！",
          type: "success",
        })
        this.yongAudioMessage = "更新音频 " + data.success + "; 忽略 " + data.ignore + "; 错误 " + data.fail;
      } else {
        this.$message({
          message: (params && params.message) ? params.message : "处理失败！",
          type: "error",
        })
      }
      this.yongAudioUploading = false
      this.$refs.yongAudioUploader.clearFiles()
    },
    uploadYongAudioError(err) {
      this.$message({
        message: "上传错误！",
        type: "error",
      })
      this.yongAudioMessage = err.description ? err.description : err.toString()
      this.yongAudioUploading = false
    },
    //提交添加，修改
    submitForm(info) {
      debounce(() => {
        if (this.editForm.params.word.id == 0) {
          wordssave(this.editForm)
            .then(res => {
              if (res.code == 200) {
                this.editFormVisible = false;
                this.getlist(this.formInline);
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.$message.error("保存失败，请稍后再试！");
            });

        } else {
          wordsupdate(this.editForm)
            .then(res => {
              if (res.code == 200) {
                this.editFormVisible = false;
                this.getlist(this.formInline);
                this.$message({
                  message: "保存成功！",
                  type: "success",
                });
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              this.editFormVisible = false;
              this.$message.error("保存失败，请稍后再试！");
            });

        }


      }, 1500);
    },
    handleEditdel(id) {
      let data = {
        "data": {},
        "params": { "id": id },
      }
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          wordsdelete(data) //删除
            .then((res) => {
              // console.log("d", res);
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.getlist(this.formInline);
              } else {
                this.$message({
                  type: "info",
                  message: res.message,
                });
              }
            })
            .catch((err) => {
              //this.loading = false;
              this.$message.error("删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },


  },
};
</script>
<style>
@import "../../assets/css/index.css";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.divBox {
  /*flex-direction: row;*/
  float: left;
  position: relative;
  margin-right: 10px;
}

.imgSty {
  margin-left: 3px;
}

.delIcon {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 20px;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 145px;
  height: 145px;
  line-height: 145px;
  text-align: center;
}

.avatar {
  width: 145px;
  height: 145px;
  display: block;
}
</style>


// WEBPACK FOOTER //
// src/views/book/words.vue